// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (hover: none) and (pointer: coarse) {
    .modal-content-button:hover {
        background-color: var(--color-component-background);
        color: var(--color-component-foreground);
        stroke: var(--color-component-foreground);
        fill: var(--color-component-foreground);
    }
}

.modal-content-button.active {
    background-color: var(--color-component-hover-back);
    color: var(--color-component-hover-fore);
    stroke: var(--color-component-hover-fore);
    fill: var(--color-component-hover-fore);
}

.modal-content-button {
    display: inline-flex;
    align-items: center;
    border-color: var(--color-component-foreground);
}

.modal-button-close-wrapper {
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem;
}

.modal-button-close {
    background: none;
    border: none;
    font-size: 1.6rem;
    cursor: pointer;
    line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Controls/Button/css/ModalContentButton.css"],"names":[],"mappings":"AAGA;IACI;QACI,mDAAmD;QACnD,wCAAwC;QACxC,yCAAyC;QACzC,uCAAuC;IAC3C;AACJ;;AAEA;IACI,mDAAmD;IACnD,wCAAwC;IACxC,yCAAyC;IACzC,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB","sourcesContent":["@import '../../../css/App.css';\r\n\r\n\r\n@media (hover: none) and (pointer: coarse) {\r\n    .modal-content-button:hover {\r\n        background-color: var(--color-component-background);\r\n        color: var(--color-component-foreground);\r\n        stroke: var(--color-component-foreground);\r\n        fill: var(--color-component-foreground);\r\n    }\r\n}\r\n\r\n.modal-content-button.active {\r\n    background-color: var(--color-component-hover-back);\r\n    color: var(--color-component-hover-fore);\r\n    stroke: var(--color-component-hover-fore);\r\n    fill: var(--color-component-hover-fore);\r\n}\r\n\r\n.modal-content-button {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    border-color: var(--color-component-foreground);\r\n}\r\n\r\n.modal-button-close-wrapper {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    padding: 0.5rem;\r\n}\r\n\r\n.modal-button-close {\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.6rem;\r\n    cursor: pointer;\r\n    line-height: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
